import './App.css';
import WetherApp from './Components/WetherApp';

function App() {
  return (
    <>
    <WetherApp />
    </>
  );
}

export default App;
